<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4999 8.99976C9.675 8.99976 8.9998 8.32456 8.9998 7.49967V0H1.5001C0.675197 0 0 0.675195 0 1.50009V16.5002C0 17.3248 0.675197 18 1.5001 18H16.4999C17.3248 18 18 17.3248 18 16.4999V9.00024L10.4999 8.99976Z"
    />
    <path
      d="M17.9996 6.00005L17.999 0.750368C17.9996 0.335568 17.6634 0.000160701 17.2497 0.000160701H11.9996V1.50025H15.4375L10.5 6.43976L11.5605 7.50039L16.5 2.56249V6.00038L17.9996 6.00005Z"
    />
  </svg>
</template>
